// extracted by mini-css-extract-plugin
export default {"container":"error_boundary-module___container___a64059bf","buttons":"error_boundary-module___buttons___d97ff6c7"};